<template>
  <div class="budengyu">
    <v-app-bar app scroll-off-screen height="50" class="sub-topbar" :class="{ 'sub-topbar--home': isHome }" :color="isHome ? undefined : 'white'">
      <div :class="classname">
        <div class="d-flex justify-space-between align-center">
          <div class="align-center flex-1 d-flex">
            <router-link to="/">
              <img v-if="!isHome" height="30" src="@/assets/images/logo.png" alt="">
              <template v-else>
                <img class="sub-topbar__logo--default" height="30" src="@/assets/images/logo-white.png" alt="">
                <img class="sub-topbar__logo--scrolled" height="30" src="@/assets/images/logo.png" alt="">
              </template>
            </router-link>
            <ul class="navbar-nav navigation-navbar main-nav flex-row d-md-flex d-none justify-start flex-1 ml-6">
              <li class="nav-item mr-6">
                <router-link :class="activeLink == '/'
        ? 'text-body-1 primary--text'
        : 'text--primary text-body-1'
        " to="/">{{ $t("首页") }}</router-link>
              </li>
              <li class="nav-item mr-6">
                <router-link :class="activeLink == '/feature'
        ? 'text-body-1 primary--text'
        : 'text--primary text-body-1'
        " to="/feature">{{ $t("功能") }}</router-link>
              </li>
              <li class="nav-item mr-6">
                <router-link :class="activeLink == '/logistics'
        ? 'text-body-1 primary--text'
        : 'text--primary text-body-1'
        " to="/logistics">{{ $t("物流") }}</router-link>
              </li>
              <li class="nav-item mr-6">
                <router-link :class="activeLink == '/payment'
        ? 'text-body-1 primary--text'
        : 'text--primary text-body-1'
        " to="/payment">{{ $t("收款") }}</router-link>
              </li>
              <li class="nav-item mr-6">
                <router-link :class="activeLink == '/pricing'
        ? 'text-body-1 primary--text'
        : 'text--primary text-body-1'
        " to="/pricing">{{ $t("价格") }}</router-link>
              </li>
              <li class="nav-item mr-6">
                <router-link :class="activeLink == '/cases'
        ? 'text-body-1 primary--text'
        : 'text--primary text-body-1'
        " to="/cases">{{ $t("案例") }}</router-link>
              </li>
              <li class="nav-item  mr-6">
                <router-link :class="activeLink == '/template-index'
        ? 'text-body-1 primary--text'
        : 'text--primary text-body-1'
        " to="/template-index">{{ $t("模板市场") }}</router-link>
              </li>
               <li class="nav-item ">
                <router-link :class="activeLink == '/question'
        ? 'text-body-1 primary--text'
        : 'text--primary text-body-1'
        " to="/question">{{ $t("帮助中心") }}</router-link>
              </li>

            </ul>
          </div>
          <ul class="navbar-nav navigation-navbar flex-row justify-end align-center d-flex">

            <li class="nav-item d-none d-md-block" v-if="obj == '' && $store.state.USERINFO == null">
              <v-btn class="primary rounded-pill" depressed @click="zhuce()">{{
        $t("店铺开通")
      }}</v-btn>
            </li>
            <li class="nav-item mx-4" v-if="$store.state.USERINFO == null">

              <a :href="`${$store.state.locationOrigin}/manger_admin`" target="_blank">

                <v-btn class="rounded-pill primary--text" color="rgba(115, 49, 255, 0.10)" depressed>{{
        $t("登录") }}</v-btn>
              </a>
            </li>
            <!-- 用户菜单 -->
            <template v-else>
              <router-link to="/user-index" class="nav-item mr-2 d-none d-md-block text-decoration-none appbar-studio-entry">
                <v-btn class="rounded-pill" color="#7331FF" dark depressed small height="34">
                  <v-icon small class="mr-1">mdi-creation</v-icon>
                  {{ $t('模板中心') }}
                </v-btn>
              </router-link>
              <v-menu open-on-hover bottom offset-y close-on-content-click open-delay="120" close-delay="80" nudge-bottom="6">
                <template v-slot:activator="{ on, attrs }">
                  <li class="nav-item d-flex align-center mx-2" v-bind="attrs" v-on="on" style="cursor:pointer">
                    <v-avatar size="34" class="appbar-avatar">
                      <img v-if="$store.state.USERINFO.avatar" :src="$store.state.USERINFO.avatar" alt="">
                      <v-icon v-else size="20" color="#fff">mdi-account</v-icon>
                    </v-avatar>
                  </li>
                </template>
                <v-card width="230" class="appbar-user-menu">
                  <div class="user-head">
                    <v-avatar size="44" class="user-head-avatar">
                      <img v-if="$store.state.USERINFO.avatar" :src="$store.state.USERINFO.avatar" alt="">
                      <v-icon v-else size="24" color="#fff">mdi-account</v-icon>
                    </v-avatar>
                    <div class="user-head-meta">
                      <p class="user-head-name">{{ $store.state.USERINFO.nickname || $t('用户') }}</p>
                      <p class="user-head-mail">{{ $store.state.USERINFO.mobile || $store.state.USERINFO.email }}</p>
                    </div>
                  </div>
                  <v-divider class="my-0"></v-divider>
                  <div class="user-menu-list">
                    <router-link to="/user-index" class="text-decoration-none">
                      <div class="user-menu-item">
                        <span class="menu-icon purple"><v-icon size="18" color="#7331FF">mdi-creation</v-icon></span>
                        <span class="menu-text">{{ $t('模板中心') }}</span>
                        <v-icon size="16" color="#C3CAD6" class="ml-auto">mdi-chevron-right</v-icon>
                      </div>
                    </router-link>
                    <a :href="`${$store.state.locationOrigin}/manger_admin`" target="_blank" class="text-decoration-none">
                      <div class="user-menu-item">
                        <span class="menu-icon blue"><v-icon size="18" color="#5268F2">mdi-store-outline</v-icon></span>
                        <span class="menu-text">{{ $t('小店管理') }}</span>
                        <v-icon size="16" color="#C3CAD6" class="ml-auto">mdi-chevron-right</v-icon>
                      </div>
                    </a>
                  </div>
                  <v-divider class="my-0"></v-divider>
                  <div class="user-menu-item logout-item" @click="logout">
                    <span class="menu-icon red"><v-icon size="18" color="#FF5252">mdi-logout</v-icon></span>
                    <span class="menu-text">{{ $t('退出登录') }}</span>
                  </div>
                </v-card>
              </v-menu>
            </template>


            <!-- 语言切换（中/EN 双段） -->
            <div class="lang-switch">
              <span class="lang-opt" :class="{ active: langdef.langsign === 'zh-CN' }" @click="langChang(langZh)">
                中
              </span>
              <span class="lang-opt" :class="{ active: langdef.langsign === 'en' }" @click="langChang(langEn)">
                EN
              </span>
            </div>

            <v-menu offset-y >
              <template v-slot:activator="{ on, attrs }">
                <v-icon size="30" v-bind="attrs" v-on="on" class="d-flex d-md-none ml-3">mdi-menu</v-icon>
              
              </template>
              <v-list>
                <ul class="px-4">
                  <li class="text-center py-2">
                    <router-link :class="activeLink == '/'
        ? 'text-body-1 primary--text text-center'
        : 'text-center text--primary text-body-1'
        " to="/">{{ $t("首页") }}</router-link>
                  </li>
                  <li class="text-center py-2">
                    <router-link :class="activeLink == '/feature'
        ? 'text-body-1 primary--text text-center'
        : 'text-center text--primary text-body-1'
        " to="/feature">{{ $t("功能") }}</router-link>
                  </li>

                  <li class="text-center py-2">
                    <router-link :class="activeLink == '/logistics'
        ? 'text-body-1 primary--text text-center'
        : 'text-center text--primary text-body-1'
        " to="/logistics">{{ $t("物流") }}</router-link>
                  </li>

                  <li class="text-center py-2">
                    <router-link :class="activeLink == '/payment'
        ? 'text-body-1 primary--text text-center'
        : 'text-center text--primary text-body-1'
        " to="/payment">{{ $t("收款") }}</router-link>
                  </li>

                  <li class="text-center py-2">
                    <router-link :class="activeLink == '/pricing'
        ? 'text-body-1 primary--text text-center'
        : 'text-center text--primary text-body-1'
        " to="/pricing">{{ $t("价格") }}</router-link>
                  </li>

                  <li class="text-center py-2">
                    <router-link :class="activeLink == '/cases'
        ? 'text-body-1 primary--text text-center'
        : 'text-center text--primary text-body-1'
        " to="/cases">{{ $t("案例") }}</router-link>
                  </li>
                  <li class="text-center py-2" v-if="obj == '' && $store.state.USERINFO == null">
                    <v-btn class="primary rounded-pill" depressed @click="zhuce()">{{ $t("立即免费开通") }}</v-btn>
                  </li>

                </ul>
              </v-list>
            </v-menu>
          </ul>

        </div>
      </div>
    </v-app-bar>

  </div>
</template>
<script>
export default {
  name: "BaseAppBar",
  data() {
    return {
      activeLink: "/",
      userinfos: "",
      classname: "container px-0",
      langdef: "",
      langList: [
        {
          name: "中文",
          langsign: "zh-CN",
          img: require("@/assets/images/recruit/guoqi1.png"),
        },
        {
          name: "English",
          langsign: "en",
          img: require("@/assets/images/recruit/en.png"),
        },
      ],
      obj: "",
    };
  },
  created() {
    let objs = {
      "id": "11",
      "username": "895507564@qq.com",
      "nickname": "895507564@qq.com",
      "avatar": "",
      "mobile": "18789895858",
      "email": "895507564@qq.com",
      "status": "1",
      "is_admin": "1",
      "auth_group_arr": [
        "2"
      ],
      "token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpc3MiOiIiLCJhdWQiOiJxc3MiLCJpYXQiOjE2OTA1MTQ3MjMsIm5iZiI6MTY5MDUxNDcyMywiZXhwIjoxNjkxODEwNzIzLCJ1aWQiOiIxMSIsImlwIjoiMTkyLjE2OC4zMS4xNTEifQ.ckFXeSIBjrn-D6MW0yu-f3vyLtOduKGnHpGcAHfOLt_sCsFR7YMe2NLFWCcoulNoIqGmhSfUTFq6JomUjZ6HzA",
      "admin_id": "11",
      "shop_id": "1012",
      "usable_text_trans": "319",
      "usable_img_trans": "390"
    }
    //  localStorage.setItem('DROPSHOPUSERINFO',JSON.stringify(objs))
  },
  mounted() {
    for (let item of this.langList) {
      if (this.$store.state.langdef == item.langsign) {
        this.langdef = item;
      }
    }
    this.activeLink = window.location.pathname;
    this.setClass();

  },
  watch: {
    $route(to, from) {
      this.activeLink = to.path;
      this.setClass();
    },
  },
  computed: {
    isHome () {
      return this.$route && (this.$route.path === '/' || this.$route.name === 'Home')
    },
    langZh() {
      return this.langList.find(l => l.langsign === 'zh-CN') || this.langList[0];
    },
    langEn() {
      return this.langList.find(l => l.langsign === 'en') || this.langList[1];
    },
  },
  methods: {
    langChang(item) {
      this.langdef = item;
      this.$store.commit("setLangDef", item.langsign);
      this.$i18n.locale = item.langsign;
      // Re-trigger SEO for current route in new language
      const path = this.$route.path;
      this.$router.replace({ path, query: this.$route.query, hash: this.$route.hash }).catch(() => {});
    },
    setClass() {
      // if (this.activeLink == "/sign-up" || this.activeLink == "/success") {
      //   this.classname = "container px-0";
      // } else {
      //   this.classname = "container px-0";
      // }
      if (
        localStorage.getItem("shop") != undefined &&
        localStorage.getItem("shop")
      ) {
        this.obj = JSON.parse(localStorage.getItem("shop"));
      }
    },
    zhuce() {
      this.$router.push({
        path: "/sign-up",
      });
    },
    logout() {

      this.$store.commit("setUSERINFO", null);
      localStorage.removeItem("DROPSHOPUSERINFO");
      localStorage.removeItem("dropshoplocalconfig");
      localStorage.removeItem("SHOPLIST");
      localStorage.removeItem("defaultShopid");
      localStorage.removeItem("DROPSHOPINFO");
      localStorage.removeItem("shop_web_domain");
      this.$router.push("/sign-up");
    },
  },
  destroyed() { },
};
</script>
<style lang="scss" scoped>
$z-index-sub-topbar: 2;
$md: 959px;
$z-99: 99;

.z-999 {
  z-index: 999;
}

.top-bar {
  height: 40px;
  display: flex;
  align-items: center;
}

.sale-page-one {
  .sub-topbar {
    &.v-app-bar--is-scrolled {
      position: relative;

      .dropdown-ecommerce {
        display: none;
      }
    }
  }

  .navbar {
    &.v-app-bar--is-scrolled {
      top: 0;
      margin-bottom: 0px;
    }
  }
}

.sale-page-two {
  .sub-topbar {
    &.v-app-bar--is-scrolled {
      position: relative;

      .dropdown-ecommerce {
        display: none;
      }
    }
  }

  .navbar {
    &.v-app-bar--is-scrolled {
      top: 0;
      margin-bottom: 0px;
    }
  }
}

.sub-topbar {
  position: relative;
  box-shadow: none !important;
  width: 100%;
  height: 50px !important;
  z-index: $z-99;

  .dropdown-ecommerce {
    display: none;
  }

  &.v-app-bar--fixed {
    position: unset;
  }

  // z-index: $z-index-sub-topbar;

  .appbar-avatar {
    border: 2px solid transparent;
    transition: border-color .3s;
  }

  .appbar-lang-btn {
    transition: color .3s;
  }

  /* 中/EN 双段语言切换 */
  .lang-switch {
    display: flex;
    align-items: center;
    background: rgba(0, 0, 0, 0.04);
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 18px;
    padding: 3px;
    margin-left: 6px;

    .lang-opt {
      padding: 4px 12px;
      border-radius: 14px;
      font-size: 12px;
      font-weight: 700;
      line-height: 1.4;
      letter-spacing: 0.5px;
      color: #6B7280;
      cursor: pointer;
      user-select: none;
      transition: all 0.2s;

      &:hover {
        color: #7331FF;
      }

      &.active {
        background: #7331FF;
        color: #fff;
        box-shadow: 0 2px 8px rgba(115, 49, 255, 0.3);
      }
    }
  }

  /* 左侧主导航 hover 精细化 */
  .main-nav {
    .nav-item > a {
      position: relative;
      transition: color 0.2s;
      white-space: nowrap;
      font-size: 14px;

      &::after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: -8px;
        width: 0;
        height: 2px;
        border-radius: 2px;
        background: #7331FF;
        transform: translateX(-50%);
        transition: width 0.25s ease;
      }

      &:hover {
        color: #7331FF !important;

        &::after {
          width: 100%;
        }
      }
    }
  }

  /* 模板中心快捷入口 */
  .appbar-studio-entry {
    .v-btn {
      text-transform: none;
      font-weight: 700;
      letter-spacing: 0.3px;
      box-shadow: 0 4px 14px rgba(115, 49, 255, 0.32) !important;
    }
  }

  &--home {
    position: fixed !important;
    top: 0;
    background: transparent !important;
    transition: background .3s;

    .sub-topbar__logo--scrolled { display: none; }

    .appbar-avatar { border-color: rgba(255,255,255,.5); }
    .lang-switch { background: rgba(255,255,255,.15); border-color: rgba(255,255,255,.2); }
    .lang-switch .lang-opt { color: rgba(255,255,255,.85); }
    .lang-switch .lang-opt:hover { color: #fff; }

    /* 深色背景上 hover/选中项用白色（紫色看不清），下划线同步白色 */
    .main-nav .nav-item > a {
      &:hover,
      &.primary--text {
        color: #fff !important;

        &::after {
          background: #fff;
        }
      }

      &.primary--text::after {
        width: 100%;
      }
    }

    ::v-deep {
      a,
      .text--primary,
      .text-body-1 {
        color: #fff !important;
      }
      .v-btn {
        color: #fff !important;
      }
      .v-icon {
        color: #fff !important;
      }
    }

    &.v-app-bar--is-scrolled {
      background: #fff !important;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;

      .sub-topbar__logo--default { display: none; }
      .sub-topbar__logo--scrolled { display: inline; }

      .appbar-avatar { border-color: rgba(0,0,0,.08); }
      .lang-switch { background: rgba(0,0,0,.04); border-color: rgba(0,0,0,.06); }
      .lang-switch .lang-opt { color: #6B7280; }
      .lang-switch .lang-opt:hover { color: #7331FF; }

      ::v-deep {
        a,
        .text--primary {
          color: rgba(0, 0, 0, 0.87) !important;
        }
        .text-body-1 {
          color: rgba(0, 0, 0, 0.87) !important;
        }
        .primary--text {
          color: #7331FF !important;
        }
        .v-btn:not(.primary) {
          color: rgba(0, 0, 0, 0.87) !important;
        }
        .v-icon {
          color: rgba(0, 0, 0, 0.87) !important;
        }
      }
    }
  }

  &.v-app-bar--is-scrolled {
    position: fixed;
    top: 0;
    box-shadow: none !important;

    .dropdown-ecommerce {
      display: block;
    }
  }

  @media (max-width: $md) {}
}

.navbar {
  height: 60px;
  width: 100%;
  z-index: 2;
  box-shadow: rgb(43 52 69 / 10%) 0px 16px 16px -16px !important;

  &.v-app-bar--is-scrolled {
    position: relative;
    top: 64px;
    margin-bottom: 64px;
    box-shadow: rgb(43 52 69 / 10%) 0px 16px 16px -16px !important;
    // box-shadow: none !important;
  }

  @media (max-width: 992px) {
    display: none;
  }
}

.search-bar {
  .search-bar-dropdown {
    position: absolute;
    right: 0;
    border-radius: 22px;

    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    height: 40px;
    box-shadow: none !important;

    @media (max-width: $md) {
      display: none;
    }
  }

  ::v-deep .v-text-field__details {
    display: none;
  }
}

// toggleNavbarButton
.navbar-toggle-dropdown {
  z-index: 98;
  display: none;

  &.open {
    display: block;
    top: 64px;
  }
}

.w23 {
  max-width: 23px;
}
</style>
<style lang='scss'>
.search-btn {
  margin-top: -6px;
  margin-right: -20px;
  height: 34px !important;

  span {
    font-size: 16px;
  }
}

/* ===== 头像弹出框 / 语言菜单（v-menu 内容 teleport 到 body，scoped 不生效，必须全局） ===== */
.appbar-user-menu,
.appbar-lang-menu {
  border-radius: 14px !important;
  overflow: hidden;
  border: 1px solid #EEF1F5;
  box-shadow: 0 12px 36px rgba(15, 52, 96, 0.14) !important;
}

.appbar-user-menu {
  .user-head {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    background: linear-gradient(135deg, #7331FF 0%, #5B21D8 100%);

    .user-head-avatar {
      border: 2px solid #fff;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
      flex-shrink: 0;
    }

    .user-head-meta {
      min-width: 0;

      .user-head-name {
        font-size: 15px;
        font-weight: 700;
        color: #fff;
        margin-bottom: 2px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .user-head-mail {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.75);
        margin-bottom: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .user-menu-list {
    padding: 6px;
  }

  .user-menu-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 12px;
    border-radius: 10px;
    cursor: pointer;
    transition: background 0.2s;

    .menu-icon {
      width: 30px;
      height: 30px;
      border-radius: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;

      &.purple { background: #7331FF; }
      &.blue { background: #5268F2; }
      &.red { background: #FF5252; }

      .v-icon { color: #fff !important; }
    }

    .menu-text {
      font-size: 13px;
      font-weight: 600;
      color: #3A4657;
    }

    &:hover {
      background: rgba(115, 49, 255, 0.06);

      .menu-text {
        color: #7331FF;
      }
    }

    &.logout-item {
      padding: 10px 12px;
      margin: 0 6px 6px;
      width: calc(100% - 12px);

      .menu-text {
        color: #FF5252;
      }

      &:hover {
        background: rgba(255, 82, 82, 0.08);
      }
    }
  }
}
</style>